<template>
  <div class="modal fade" id="addUnitScoreModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="Unit != null" class="modal-title">
            New Data for {{ Unit.Title }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          v-if="Unit != null && Unit.Score_Template != null"
          class="modal-body"
        >
          <div v-if="errorMessage != ''" class="text-danger">
            <p>{{ errorMessage }}</p>
          </div>
          <form
            @submit.prevent="submitSubject"
            v-if="page == 1 && Students.length > 0"
          >
            <div class="text-left mb-2">
              <div class="form-group">
                <label v-bind:for="'assignment'">Score Title</label>
                <input
                  type="text"
                  class="form-control"
                  id="assignment"
                  placeholder="Ex. Assignment 1, Writing Prompt 3, etc."
                  v-model="assignment"
                  required
                />
              </div>
              <div class="form-group">
                <label v-bind:for="'date'">Date</label>
                <input
                  type="date"
                  class="form-control"
                  id="date"
                  v-model="date"
                  required
                />
              </div>
              <p class="mb-0">For which students would you like to add data?</p>
              <button
                type="button"
                class="btn btn-link"
                v-on:click="selectAllStudents"
              >
                All Students
              </button>
            </div>
            <div
              v-for="student in Students"
              :key="student.Student_Id"
              class="form-group form-check"
            >
              <input
                type="checkbox"
                class="form-check-input"
                v-bind:id="student.Student_Id + 'student'"
                v-bind:value="student"
                v-model="scoreStudents"
              />
              <label
                class="form-check-label"
                v-bind:for="student.Student_Id + 'student'"
                >{{ student.Name }}</label
              >
            </div>
          </form>
          <div
            v-for="templateInput in Unit.Score_Template.Score_Template_Inputs"
            :key="templateInput.Score_Template_Input_Id"
          >
            <form v-if="page == 1 + templateInput.Order">
              <EnterScoreRow
                v-bind:Input="templateInput"
                v-bind:StudentInputs="studentInputs"
                @input-change="inputChanged"
              />
            </form>
          </div>
          <div
            v-if="page == 2 + Unit.Score_Template.Score_Template_Inputs.length"
            class="mb-4 row"
          >
            <div class="col-12">
              <h5 class="mb-0"><strong>Review</strong></h5>
            </div>
            <div
              v-for="studentInput in studentInputs"
              :key="studentInput.student.Student_Id"
              class="text-left col-6"
            >
              <p class="mb-0 mt-2">
                <strong>{{ studentInput.student.Name }}</strong>
              </p>
              <div
                v-for="input in studentInput.inputs"
                :key="studentInput.student.Student_Id + 'input' + input.order"
              >
                <p class="mb-0">
                  {{
                    Unit.Score_Template.Score_Template_Inputs.find(
                      i => i.Order == input.order
                    ).Request
                  }}
                </p>
                <p class="mb-0">
                  <strong>{{
                    $prettifyInput(
                      input.input,
                      Unit.Score_Template.Score_Template_Inputs.find(
                        i => i.Order == input.order
                      )
                    )
                  }}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col text-left">
              <button
                v-if="page != 1"
                type="button"
                class="btn btn-danger"
                v-on:click="previousPage"
              >
                Back
              </button>
              <button
                v-else
                type="button"
                class="btn btn-danger"
                v-on:click="cancel"
              >
                Cancel
              </button>
            </div>
            <div class="col-auto">
              <button
                v-if="
                  page == 2 + Unit.Score_Template.Score_Template_Inputs.length
                "
                type="button"
                class="btn btn-primary"
                v-on:click="addData"
              >
                Add Data
              </button>
              <button
                v-else
                v-on:click="nextPage"
                type="button"
                class="btn btn-primary"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import EnterScoreRow from "@/components/Score/EnterScoreRow.vue";

export default {
  components: {
    EnterScoreRow
  },
  props: {
    Unit: Object,
    Students: Array
  },
  data() {
    return {
      scoreStudents: [],
      page: 1,
      errorMessage: "",
      assignment: "",
      studentInputs: [],
      date: this.$dateToYYYYMMDD(new Date())
    };
  },
  mounted() {
    //var view = this;
    /*document.getElementById("phone").onkeyup = function(e) {
      view.$phoneNumberCheck(this, e);
    };*/
    $("#addUnitScoreModal").on("shown.bs.modal", function() {
      $("#scoreName").focus();
    });
  },
  watch: {
    Unit: function() {
      this.scoreStudents = [];
      this.page = 1;
    }
  },
  methods: {
    nextPage() {
      switch (this.page) {
        case 1:
          if (this.scoreStudents.length == 0) {
            this.errorMessage =
              "Please choose at least one student for which to keep data.";
          } else {
            this.errorMessage = "";
            this.createStudentInputs();
            this.page = 2;
          }
          break;
        default:
          this.page = this.page + 1;
          break;
      }
    },
    previousPage() {
      this.page = this.page - 1;
    },
    cancel() {
      $("#addUnitScoreModal").modal("hide");
      this.clearForm();
    },
    selectAllStudents() {
      this.scoreStudents = this.Students;
    },
    inputChanged(input, studentInput) {
      var studentInputIndex = this.studentInputs.findIndex(
        i => i.student.Student_Id == studentInput.student.Student_Id
      );
      var inputIndex = this.studentInputs[studentInputIndex].inputs.findIndex(
        i => i.order == input.Order
      );
      this.studentInputs[studentInputIndex].inputs[
        inputIndex
      ].input = studentInput.inputs.find(i => i.order == input.Order).input;
    },
    createStudentInputs() {
      this.studentInputs = [];
      this.scoreStudents.forEach(student => {
        var length = this.studentInputs.push({ student: student, inputs: [] });
        this.Unit.Score_Template.Score_Template_Inputs.forEach(input => {
          this.studentInputs[length - 1].inputs.push({
            order: input.Order,
            input: this.$getInputDefaultValue(input)
          });
        });
      });
    },
    async addData() {
      $("#addUnitScoreModal").modal("hide");
      this.$store.commit("updateLoading", true);
      for (let i = 0; i < this.studentInputs.length; i++) {
        const studentInput = this.studentInputs[i];
        await this.$createScore(
          this.assignment,
          studentInput.student.Student_Id,
          this.Unit.Unit_Id,
          studentInput.inputs,
          this.date
        );
      }
      this.scoreStudents = [];
      this.page = 1;
      this.$store.commit("updateLoading", false);
      this.$emit("added-scores");
      this.clearForm();
    },
    clearForm() {
      this.scoreStudents = [];
      this.page = 1;
      this.errorMessage = "";
      this.assignment = "";
      this.studentInputs = [];
      this.date = this.$dateToYYYYMMDD(new Date());
    }
  }
};
</script>
